import React, {useCallback, useMemo} from 'react';
import {StrapiLayout, TopCard, IconGrid, KlearMap, AboutCard, RecruitSection} from "@klear/open-site";
import useIndexData from "../data/indexData";

const {Helmet} = require("react-helmet");

const styles = require('../styles/aboutus-document.module.scss');

export default () => {
     const allData = useIndexData();
     const aboutUsData = allData.strapiAbout;
     const footerData = allData.strapiFooter;

    const topCardContent = useMemo(() =>
            <img src={aboutUsData.topCard.image?.url} alt=""/>
        , []);

    const getIsReverseDirection = useCallback((index) => {
        return !!(index % 2);
    }, []);

    const aboutMWTitle = useMemo(() =>
        <h2 className={styles.aboutMW}>Our Values</h2> , []);

    return (
        <StrapiLayout footerProps={footerData}>
            <Helmet>
                <title>{aboutUsData.title}</title>
                <meta name="description" content={aboutUsData.description}/>
            </Helmet>
            <div className={styles.container}>
                <TopCard {...aboutUsData.topCard} horizontalTopCard reverseCard topCardContent={topCardContent} />

                <IconGrid  {...aboutUsData.iconGrid} />

                <AboutCard {...aboutUsData.aboutCard}>
                    {aboutMWTitle}
                </AboutCard>

                <KlearMap {...aboutUsData.aboutMap} />

                {aboutUsData.aboutUsCards &&
                    aboutUsData.aboutUsCards.map((card, index) =>
                        <AboutCard key={index} {...card} reverseDirection={getIsReverseDirection(index)} />
                    )}


                <RecruitSection {...aboutUsData.recruit} lastSection />
            </div>
        </StrapiLayout>

    );
};